import Icon from '../components/Icon';

const DoubleBack = Icon(
  'double-back',
  <>
    <path d="M16.97 11.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H3.5a.75.75 0 0 0 0 1.5h15.19l-1.72 1.72a.75.75 0 0 0 0 1.06M6.03 18.97a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72h6.19a.75.75 0 0 1 0 1.5H4.31zM13 15.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zM15.75 16.5a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M20 15.75a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z" />
  </>
);

export default DoubleBack;
